import axios from 'axios';

export interface ErrorEmpleado {
  mensaje: string;
  /** Detalle de una validación del servidor (400), un motivo por línea. */
  faltas?: string[];
  estado?: number;
}

const GENERICO = 'No se ha podido completar la operación. Inténtalo de nuevo en unos minutos.';

/**
 * Traduce el error de la API de Empleados. Los 4xx (404, 409, 422…) y los 502 y 503 traen su mensaje redactado
 * para el usuario: se muestra tal cual. Un 400 trae un motivo por campo. Cualquier otro fallo
 * sale con un texto genérico, sin detalles de servidor.
 */
export const errorEmpleado = (error: unknown): ErrorEmpleado => {
  if (axios.isAxiosError(error) && error.response) {
    const { status, data } = error.response as {
      status: number;
      data?: { title?: string; detail?: string; errors?: Record<string, string[]> };
    };
    if (status === 400 && data?.errors) {
      const faltas = Object.values(data.errors).flat();
      if (faltas.length) return { mensaje: 'Revisa los datos introducidos.', faltas, estado: status };
    }
    if (status === 403) return { mensaje: data?.detail || 'No tienes permiso para hacer esto.', estado: status };
    if ((status >= 400 && status < 500) || status === 502 || status === 503) {
      return { mensaje: data?.detail || data?.title || GENERICO, estado: status };
    }
    return { mensaje: GENERICO, estado: status };
  }
  return { mensaje: GENERICO };
};
